export const LOADING_DOCUMENT = "LOADING_DOCUMENT";
export const REMOVE_DOCUMENT = "REMOVE_DOCUMENT";
export const ADD_DOCUMENT = "ADD_DOCUMENT";
export const ADD_MULTI_DOCUMENT = "ADD_MULTI_DOCUMENT";
export const DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT";
export const GET_DOCUMENT_LIST = "GET_DOCUMENT_LIST";
export const FILE_SHARING = "FILE_SHARING";